import React from 'react'
import './styles.scss'

export default function ModalDialog({ active, title, onClose, children, hideHeader = false }) {
  return (
    <div className={`modal ${active ? 'is-active' : ''}`}>
      <div className='modal-background' onClick={onClose} />
      <div className={`modal-card`}>
        {!hideHeader && (
          <header className='modal-card-head'>
            <p className='modal-card-title'>{title}</p>
            {onClose && (
              <button className='delete' aria-label='close' onClick={onClose} />
            )}
          </header>
        )}
        <section className={`modal-card-body ${hideHeader ? 'p-0' : ''}`}>{children}</section>
      </div>
    </div>
  )
}
